function GuaranteeSection() {
  return null;
}

export default GuaranteeSection;
